<!-- eslint-disable max-len -->
<template>
  <div>
    <LoadingSpinner v-if="loading" />

    <div class="block relative">
      <div class="body_inner">
        <h2
          class="
            page-title
            block
            relative
            text-darkgray
            font-bold
            text-lgg text-center
            mb-4
          "
        >
          {{ $t("pages.favorites.title") }}
        </h2>
        <button
          class="
            relative
            flex
            items-center
            justify-center
            flex-nowrap
            text-sm
            walter-footer
            p-1.5
            border
            solid
            border-darkgreen
            rounded
            w-full
            text-center
            bg-darkgreen
            h-12
            mb-2
            text-white
          "
          @click="showFilters = !showFilters"
        >
          <span class="mr-2-8">
            <svg
              class="w-5 h-5"
              width="19"
              height="18"
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.75 0C1.0682 0 0.5 0.568203 0.5 1.25V2.79492C0.5 3.94325 1.02774 5.02942 1.92969 5.74023L7 9.73535V17.25C7.00007 17.3877 7.03806 17.5228 7.10981 17.6404C7.18155 17.7579 7.28429 17.8535 7.40674 17.9165C7.5292 17.9796 7.66665 18.0077 7.80403 17.9978C7.94141 17.9879 8.0734 17.9403 8.18555 17.8604L11.6855 15.3604C11.7828 15.291 11.862 15.1994 11.9167 15.0933C11.9714 14.9871 12 14.8694 12 14.75V9.73438L17.0703 5.74023C17.9723 5.02942 18.5 3.94325 18.5 2.79492V1.25C18.5 0.568203 17.9318 0 17.25 0H1.75ZM2 1.5H17V2.79492C17 3.4846 16.6846 4.13434 16.1426 4.56152L11.1436 8.5H7.85645L2.85742 4.56152C2.31537 4.13434 2 3.4846 2 2.79492V1.5ZM8.5 10H10.5V14.3643L8.5 15.793V10Z"
                fill="white"
              />
            </svg>
          </span>
          {{ $t("pages.favorites.buttons.filter") }}
        </button>

        <div class="form-group block relative mt-2 mb-2">
          <label
            class="
              block
              relative
              flex
              items-center
              justify-start
              text-sm
              font-medium
              pt-1
              pb-2
            "
            @click="showSortingOptions = !showSortingOptions"
          >
            {{ $t("pages.favorites.buttons.sort.title") }}
            <span v-if="!showSortingOptions" class="flex ml-1.5">
              <svg
                class="w-3 h-3"
                viewBox="0 0 16 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                
              >
                <path
                  d="M14.4957 0.992327C14.3637 0.995445 14.2382 1.05068 14.1467 1.14597L8.00025 7.29246L1.85377 1.14597C1.80716 1.09798 1.7514 1.05982 1.68978 1.03377C1.62817 1.00771 1.56195 0.994283 1.49505 0.99428C1.39554 0.994304 1.2983 1.02402 1.21577 1.07961C1.13325 1.13521 1.06919 1.21417 1.03178 1.30638C0.994383 1.39859 0.985343 1.49986 1.00582 1.59724C1.0263 1.69462 1.07536 1.78367 1.14674 1.853L7.64674 8.353C7.74051 8.44674 7.86767 8.49939 8.00025 8.49939C8.13284 8.49939 8.26 8.44674 8.35377 8.353L14.8538 1.853C14.9265 1.78322 14.9764 1.69309 14.997 1.59444C15.0176 1.49578 15.0079 1.39321 14.9692 1.30016C14.9305 1.20711 14.8646 1.12793 14.7801 1.073C14.6956 1.01807 14.5964 0.989947 14.4957 0.992327Z"
                  fill="#63B15B"
                />
              </svg>
            </span>
             <div
            v-if="!loading"
            class="
              absolute
              inset-0
              flex
              items-center
              justify-center
              pl-10
              pr-10
              offer_main_block
            "
          >
            <div
              class="offerno_result"
              style="
                display: block;
                position: relative;
                padding: 20px 20px 20px;
                margin-top: 509px;
              "
              v-if="offers.length === 0"
            >
              <div class="flex items-center justify-center iconbox">
               
              </div>
              <h5 style="text-align: center">
                {{ $t("pages.offers.no_result.heading") }}
              </h5>
              <p class="font-normal" style="text-align: center">
                {{ $t("pages.offers.no_result.description") }}
              </p>
              <p>
                <a
                  style="display: block; width: 100px; margin: 0 auto"
                  class="reset_fill"
                  @click="resetFilter"
                >
                  {{ $t("pages.common.buttons.dis150") }}
                </a>
              </p>
            </div>
          </div>
            <span v-if="showSortingOptions" class="flex ml-1.5">
              <svg
                class="w-3 h-3"
                width="16"
                height="9"
                viewBox="0 0 16 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.4955 8.00767C14.3634 8.00455 14.238 7.94932 14.1465 7.85403L8.00001 1.70754L1.85353 7.85403C1.80692 7.90202 1.75116 7.94018 1.68954 7.96623C1.62792 7.99229 1.5617 8.00572 1.4948 8.00572C1.39529 8.0057 1.29806 7.97598 1.21553 7.92039C1.133 7.86479 1.06894 7.78583 1.03154 7.69362C0.994139 7.60141 0.985099 7.50014 1.00558 7.40276C1.02605 7.30538 1.07512 7.21633 1.14649 7.147L7.64649 0.646997C7.74027 0.553264 7.86742 0.50061 8.00001 0.50061C8.1326 0.50061 8.25975 0.553264 8.35353 0.646997L14.8535 7.147C14.9262 7.21678 14.9762 7.30691 14.9968 7.40556C15.0174 7.50422 15.0077 7.60679 14.969 7.69984C14.9302 7.79289 14.8643 7.87207 14.7798 7.927C14.6953 7.98193 14.5962 8.01005 14.4955 8.00767V8.00767Z"
                  fill="#63B15B"
                />
              </svg>
            </span>
          </label>
         
          <div
            v-if="showSortingOptions"
            class="
              absolute
              top-100
              left-0
              w-64
              bg-white
              rounded-lg
              walter-shadow
              z-50
            "
          >
            <ul class="block w-full h-full p-4 m-0">
              <li class="nav-item w-full mb-0" @click="sort('earning', 'asc')">
                <a
                  href="javascript:void(0)"
                  class="nav-link flex items-center justify-between pt-1 pb-1"
                >
                  <span
                    :class="
                      orderBy === 'earning' && sortDir === 'asc'
                        ? 'text-darkgray1 font-bold'
                        : 'text-darkgray font-medium'
                    "
                    class="text pr-1 text-sm"
                  >
                    {{ $t("pages.favorites.buttons.sort.earning_asc") }}
                  </span>
                  <span
                    v-if="orderBy === 'earning' && sortDir === 'asc'"
                    class="icons"
                  >
                    <svg
                      width="14"
                      height="10"
                      class="w-3 h-3"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3896 0.194568C13.251 0.198696 13.1195 0.256605 13.0229 0.356026L4.86668 8.51228L1.51043 5.15603C1.46128 5.10484 1.40242 5.06398 1.33729 5.03582C1.27215 5.00767 1.20205 4.9928 1.1311 4.99208C1.06014 4.99135 0.989758 5.0048 0.924063 5.03162C0.858368 5.05844 0.798686 5.0981 0.748511 5.14827C0.698335 5.19845 0.658676 5.25813 0.631855 5.32383C0.605034 5.38952 0.591591 5.45991 0.592313 5.53086C0.593035 5.60182 0.607907 5.67192 0.636059 5.73705C0.664211 5.80219 0.705077 5.86105 0.756262 5.91019L4.4896 9.64353C4.58962 9.74351 4.72525 9.79967 4.86668 9.79967C5.0081 9.79967 5.14374 9.74351 5.24376 9.64353L13.7771 1.11019C13.8542 1.03528 13.9068 0.938831 13.9281 0.833487C13.9494 0.728143 13.9384 0.618818 13.8965 0.519839C13.8546 0.42086 13.7838 0.336845 13.6934 0.278802C13.6029 0.22076 13.497 0.1914 13.3896 0.194568Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </a>
              </li>

              <li class="nav-item w-full mb-0" @click="sort('earning', 'desc')">
                <a
                  href="javascript:void(0)"
                  class="nav-link flex items-center justify-between pt-1 pb-1"
                >
                  <span
                    :class="
                      orderBy === 'earning' && sortDir === 'desc'
                        ? 'text-darkgray1 font-bold'
                        : 'text-darkgray font-medium'
                    "
                    class="text pr-1 text-sm"
                  >
                    {{ $t("pages.favorites.buttons.sort.earning_desc") }}
                  </span>
                  <span
                    v-if="orderBy === 'earning' && sortDir === 'desc'"
                    class="icons"
                  >
                    <svg
                      width="14"
                      height="10"
                      class="w-3 h-3"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3896 0.194568C13.251 0.198696 13.1195 0.256605 13.0229 0.356026L4.86668 8.51228L1.51043 5.15603C1.46128 5.10484 1.40242 5.06398 1.33729 5.03582C1.27215 5.00767 1.20205 4.9928 1.1311 4.99208C1.06014 4.99135 0.989758 5.0048 0.924063 5.03162C0.858368 5.05844 0.798686 5.0981 0.748511 5.14827C0.698335 5.19845 0.658676 5.25813 0.631855 5.32383C0.605034 5.38952 0.591591 5.45991 0.592313 5.53086C0.593035 5.60182 0.607907 5.67192 0.636059 5.73705C0.664211 5.80219 0.705077 5.86105 0.756262 5.91019L4.4896 9.64353C4.58962 9.74351 4.72525 9.79967 4.86668 9.79967C5.0081 9.79967 5.14374 9.74351 5.24376 9.64353L13.7771 1.11019C13.8542 1.03528 13.9068 0.938831 13.9281 0.833487C13.9494 0.728143 13.9384 0.618818 13.8965 0.519839C13.8546 0.42086 13.7838 0.336845 13.6934 0.278802C13.6029 0.22076 13.497 0.1914 13.3896 0.194568Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </a>
              </li>

              <li
                class="nav-item w-full mb-0"
                @click="sort('arrival_date', 'asc')"
              >
                <a
                  href="javascript:void(0)"
                  class="nav-link flex items-center justify-between pt-1 pb-1"
                >
                  <span
                    :class="
                      orderBy === 'arrival_date' && sortDir === 'asc'
                        ? 'text-darkgray1 font-bold'
                        : 'text-darkgray font-medium'
                    "
                    class="text pr-1 text-sm"
                  >
                    {{ $t("pages.favorites.buttons.sort.arrival_asc") }}
                  </span>
                  <span
                    v-if="orderBy === 'arrival_date' && sortDir === 'asc'"
                    class="icons"
                  >
                    <svg
                      width="14"
                      height="10"
                      class="w-3 h-3"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3896 0.194568C13.251 0.198696 13.1195 0.256605 13.0229 0.356026L4.86668 8.51228L1.51043 5.15603C1.46128 5.10484 1.40242 5.06398 1.33729 5.03582C1.27215 5.00767 1.20205 4.9928 1.1311 4.99208C1.06014 4.99135 0.989758 5.0048 0.924063 5.03162C0.858368 5.05844 0.798686 5.0981 0.748511 5.14827C0.698335 5.19845 0.658676 5.25813 0.631855 5.32383C0.605034 5.38952 0.591591 5.45991 0.592313 5.53086C0.593035 5.60182 0.607907 5.67192 0.636059 5.73705C0.664211 5.80219 0.705077 5.86105 0.756262 5.91019L4.4896 9.64353C4.58962 9.74351 4.72525 9.79967 4.86668 9.79967C5.0081 9.79967 5.14374 9.74351 5.24376 9.64353L13.7771 1.11019C13.8542 1.03528 13.9068 0.938831 13.9281 0.833487C13.9494 0.728143 13.9384 0.618818 13.8965 0.519839C13.8546 0.42086 13.7838 0.336845 13.6934 0.278802C13.6029 0.22076 13.497 0.1914 13.3896 0.194568Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </a>
              </li>

              <li
                class="nav-item w-full mb-0"
                @click="sort('arrival_date', 'desc')"
              >
                <a
                  href="javascript:void(0)"
                  class="nav-link flex items-center justify-between pt-1 pb-1"
                >
                  <span
                    :class="
                      orderBy === 'arrival_date' && sortDir === 'desc'
                        ? 'text-darkgray1 font-bold'
                        : 'text-darkgray font-medium'
                    "
                    class="text pr-1 text-sm"
                  >
                    {{ $t("pages.favorites.buttons.sort.arrival_desc") }}
                  </span>
                  <span
                    v-if="orderBy === 'arrival_date' && sortDir === 'desc'"
                    class="icons"
                  >
                    <svg
                      width="14"
                      height="10"
                      class="w-3 h-3"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3896 0.194568C13.251 0.198696 13.1195 0.256605 13.0229 0.356026L4.86668 8.51228L1.51043 5.15603C1.46128 5.10484 1.40242 5.06398 1.33729 5.03582C1.27215 5.00767 1.20205 4.9928 1.1311 4.99208C1.06014 4.99135 0.989758 5.0048 0.924063 5.03162C0.858368 5.05844 0.798686 5.0981 0.748511 5.14827C0.698335 5.19845 0.658676 5.25813 0.631855 5.32383C0.605034 5.38952 0.591591 5.45991 0.592313 5.53086C0.593035 5.60182 0.607907 5.67192 0.636059 5.73705C0.664211 5.80219 0.705077 5.86105 0.756262 5.91019L4.4896 9.64353C4.58962 9.74351 4.72525 9.79967 4.86668 9.79967C5.0081 9.79967 5.14374 9.74351 5.24376 9.64353L13.7771 1.11019C13.8542 1.03528 13.9068 0.938831 13.9281 0.833487C13.9494 0.728143 13.9384 0.618818 13.8965 0.519839C13.8546 0.42086 13.7838 0.336845 13.6934 0.278802C13.6029 0.22076 13.497 0.1914 13.3896 0.194568Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </a>
              </li>

              <li class="nav-item w-full mb-0" @click="sort('customer', 'asc')">
                <a
                  href="javascript:void(0)"
                  class="nav-link flex items-center justify-between pt-1 pb-1"
                >
                  <span
                    :class="
                      orderBy === 'customer' && sortDir === 'asc'
                        ? 'text-darkgray1 font-bold'
                        : 'text-darkgray font-medium'
                    "
                    class="text pr-1 text-sm"
                  >
                    {{ $t("pages.favorites.buttons.sort.customer_asc") }}
                  </span>
                  <span
                    v-if="orderBy === 'customer' && sortDir === 'asc'"
                    class="icons"
                  >
                    <svg
                      width="14"
                      height="10"
                      class="w-3 h-3"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3896 0.194568C13.251 0.198696 13.1195 0.256605 13.0229 0.356026L4.86668 8.51228L1.51043 5.15603C1.46128 5.10484 1.40242 5.06398 1.33729 5.03582C1.27215 5.00767 1.20205 4.9928 1.1311 4.99208C1.06014 4.99135 0.989758 5.0048 0.924063 5.03162C0.858368 5.05844 0.798686 5.0981 0.748511 5.14827C0.698335 5.19845 0.658676 5.25813 0.631855 5.32383C0.605034 5.38952 0.591591 5.45991 0.592313 5.53086C0.593035 5.60182 0.607907 5.67192 0.636059 5.73705C0.664211 5.80219 0.705077 5.86105 0.756262 5.91019L4.4896 9.64353C4.58962 9.74351 4.72525 9.79967 4.86668 9.79967C5.0081 9.79967 5.14374 9.74351 5.24376 9.64353L13.7771 1.11019C13.8542 1.03528 13.9068 0.938831 13.9281 0.833487C13.9494 0.728143 13.9384 0.618818 13.8965 0.519839C13.8546 0.42086 13.7838 0.336845 13.6934 0.278802C13.6029 0.22076 13.497 0.1914 13.3896 0.194568Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </a>
              </li>

              <li
                class="nav-item w-full mb-0"
                @click="sort('customer', 'desc')"
              >
                <a
                  href="javascript:void(0)"
                  class="nav-link flex items-center justify-between pt-1 pb-1"
                >
                  <span
                    :class="
                      orderBy === 'customer' && sortDir === 'desc'
                        ? 'text-darkgray1 font-bold'
                        : 'text-darkgray font-medium'
                    "
                    class="text pr-1 text-sm"
                  >
                    {{ $t("pages.favorites.buttons.sort.customer_desc") }}
                  </span>
                  <span
                    v-if="orderBy === 'customer' && sortDir === 'desc'"
                    class="icons"
                  >
                    <svg
                      width="14"
                      height="10"
                      class="w-3 h-3"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.3896 0.194568C13.251 0.198696 13.1195 0.256605 13.0229 0.356026L4.86668 8.51228L1.51043 5.15603C1.46128 5.10484 1.40242 5.06398 1.33729 5.03582C1.27215 5.00767 1.20205 4.9928 1.1311 4.99208C1.06014 4.99135 0.989758 5.0048 0.924063 5.03162C0.858368 5.05844 0.798686 5.0981 0.748511 5.14827C0.698335 5.19845 0.658676 5.25813 0.631855 5.32383C0.605034 5.38952 0.591591 5.45991 0.592313 5.53086C0.593035 5.60182 0.607907 5.67192 0.636059 5.73705C0.664211 5.80219 0.705077 5.86105 0.756262 5.91019L4.4896 9.64353C4.58962 9.74351 4.72525 9.79967 4.86668 9.79967C5.0081 9.79967 5.14374 9.74351 5.24376 9.64353L13.7771 1.11019C13.8542 1.03528 13.9068 0.938831 13.9281 0.833487C13.9494 0.728143 13.9384 0.618818 13.8965 0.519839C13.8546 0.42086 13.7838 0.336845 13.6934 0.278802C13.6029 0.22076 13.497 0.1914 13.3896 0.194568Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="listing-block block relative">
          <div
            v-for="(offer, key) in offers"
            :key="`offer_${key}`"
            class="list-items block relative"
            
          >
            <div
              v-if="!loading"
              class="
                block
                relative
                walter-block
                bg-white
                rounded-lg
                walter-shadow
                mb-4
              "
            >
             <div class="flex align-start justify-start top-block mb-0.5 p-4">
                <div class="left-block w-3/5 relative">
                  <div class="flex items-center">
                    <div class="flex items-center">
                      <h4
                        class="
                          flex
                          align-center
                          justify-start
                          relative
                          text-sm
                          font-bold
                          text-darkblack
                          flex
                          lock-text
                        "
                      ></h4>
                      {{ $t("pages.common.buttons.dis73") }}:
                      <span
                        v-if="loggedIn"
                        @click="
                          () => {
                            if (loggedIn) {
                              $router.push({
                                name: 'offerDetails',
                                params: { id: offer.offer_id },
                              });
                            } else {
                              $router.push({ name: 'confirmCell' });
                            }
                          }
                        "
                        class="ml-1"
                      >
                        {{ offer.customer.id }}
                      </span>
                      <span v-if="!loggedIn" class="text-danger ml-1">
                        locked
                      </span>
                      <svg
                        v-if="!loggedIn"
                        width="10"
                        height="11"
                        class="ml-1.5"
                        viewBox="0 0 10 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.5 5.5H1.5C0.947715 5.5 0.5 5.94772 0.5 6.5V10C0.5 10.5523 0.947715 11 1.5 11H8.5C9.05229 11 9.5 10.5523 9.5 10V6.5C9.5 5.94772 9.05229 5.5 8.5 5.5Z"
                          fill="#EE5B64"
                        />
                        <path
                          d="M2.5 5.5V3.5C2.5 2.83696 2.76339 2.20107 3.23223 1.73223C3.70107 1.26339 4.33696 1 5 1C5.66304 1 6.29893 1.26339 6.76777 1.73223C7.23661 2.20107 7.5 2.83696 7.5 3.5V5.5"
                          stroke="#EE5B64"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>

                    <div class="wrapper">
                      <svg
                        width="14"
                        height="14"
                        class="ml-1.5 show"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        v-if="offer.is_verified == true ? true : false"
                        @click="showVerifiedModal"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.26853 1.66248C5.38845 1.64971 5.51634 1.68009 5.63246 1.76143L6.2158 2.17029C6.73895 2.5362 7.44038 2.53665 7.96319 2.17029L8.54588 1.76143C8.85553 1.54451 9.25155 1.68848 9.34926 2.05375L9.53285 2.7419C9.69778 3.3585 10.2348 3.80883 10.8707 3.8643L11.5797 3.92615C11.9563 3.95901 12.1673 4.32404 12.0075 4.66638L11.706 5.31156C11.4361 5.88997 11.5577 6.58039 12.0094 7.03162L12.5127 7.53487C12.7799 7.80194 12.7069 8.21698 12.3642 8.37667L11.7191 8.67745C11.1403 8.94679 10.7903 9.5535 10.846 10.1892L10.9085 10.8988C10.9415 11.2754 10.6184 11.5463 10.2536 11.4483L9.56606 11.2634C8.94953 11.098 8.29071 11.3375 7.92478 11.8604L7.51658 12.4437C7.29985 12.7535 6.87849 12.7542 6.66176 12.4444L6.25356 11.8604C5.88763 11.3375 5.22945 11.098 4.61293 11.2634L3.92478 11.4483C3.55996 11.5463 3.23744 11.2754 3.27048 10.8988L3.33298 10.1898C3.38895 9.55391 3.03826 8.94623 2.45929 8.6768L1.8141 8.37667C1.47134 8.21692 1.39814 7.8024 1.66567 7.53487L2.16957 7.03162C2.62129 6.58039 2.74285 5.88997 2.47296 5.31156L2.17153 4.66638C2.01172 4.32404 2.22202 3.95901 2.59861 3.92615L3.30824 3.8643C3.94416 3.80883 4.48056 3.3585 4.64548 2.7419L4.82973 2.05375C4.87859 1.87112 5.00214 1.74371 5.15199 1.68917C5.18946 1.67553 5.22856 1.66673 5.26853 1.66248ZM9.14614 5.1462C9.23675 5.05311 9.36003 4.99894 9.48989 4.99516C9.59053 4.99226 9.68971 5.01981 9.77444 5.07421C9.85917 5.12861 9.92551 5.20732 9.96476 5.30005C10.004 5.39277 10.0144 5.49518 9.99446 5.59389C9.97455 5.69259 9.9253 5.78298 9.85317 5.85323L6.51983 9.18656C6.42606 9.2803 6.2989 9.33295 6.16632 9.33295C6.03373 9.33295 5.90657 9.2803 5.8128 9.18656L4.14614 7.5199C4.09815 7.47382 4.05984 7.41864 4.03345 7.35758C4.00706 7.29651 3.99311 7.2308 3.99244 7.16428C3.99176 7.09776 4.00436 7.03177 4.02951 6.97018C4.05465 6.9086 4.09183 6.85264 4.13887 6.8056C4.18591 6.75856 4.24186 6.72139 4.30345 6.69624C4.36504 6.6711 4.43103 6.65849 4.49755 6.65917C4.56407 6.65984 4.62978 6.67379 4.69085 6.70018C4.75191 6.72657 4.80709 6.76488 4.85317 6.81287L6.16632 8.12602L9.14614 5.1462Z"
                          fill="#4890D2"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.97231 0.942424C8.23866 0.755836 8.54077 0.670709 8.83884 0.672892C9.49461 0.677696 10.1299 1.10408 10.3148 1.79529L10.499 2.48344C10.5561 2.69684 10.7373 2.84901 10.9573 2.8682L11.667 2.93005C12.7037 3.02052 13.3533 4.14656 12.9131 5.08956L12.6123 5.73474C12.5188 5.935 12.5595 6.16783 12.7158 6.32393L13.2197 6.82719C13.9558 7.56279 13.7301 8.84327 12.7868 9.28292L12.1416 9.5837C11.9412 9.67694 11.8227 9.88184 11.8421 10.1019L11.9046 10.8116C11.9956 11.8483 10.9996 12.6838 9.99444 12.4138L9.30694 12.2295C9.09347 12.1723 8.87119 12.2528 8.74444 12.434L8.33624 13.0173C7.73964 13.8701 6.43935 13.8701 5.84275 13.0173L5.43455 12.434C5.3078 12.2528 5.08552 12.1723 4.87205 12.2295L4.18455 12.4138C3.17937 12.6838 2.18343 11.8483 2.27439 10.8116L2.33689 10.1019C2.35626 9.88184 2.23777 9.67694 2.03741 9.5837L1.39158 9.28292C0.448344 8.84333 0.222832 7.56299 0.958635 6.82719L1.46254 6.32393C1.61882 6.16783 1.66015 5.935 1.56671 5.73474L1.26528 5.08891C0.825081 4.14591 1.47527 3.02052 2.51202 2.93005L3.221 2.8682C3.44109 2.84901 3.62226 2.69684 3.67934 2.48344L3.86358 1.79529C4.0653 1.04124 4.80277 0.602953 5.51853 0.682658C5.75712 0.709227 5.9936 0.793154 6.20668 0.942424L6.78936 1.35128C6.97154 1.4787 7.20779 1.47824 7.38897 1.35128L7.97231 0.942424ZM5.63246 1.76143C5.51634 1.68009 5.38845 1.64971 5.26853 1.66248C5.22856 1.66673 5.18946 1.67553 5.15199 1.68917C5.00214 1.74371 4.87859 1.87112 4.82973 2.05375L4.64548 2.7419C4.48056 3.3585 3.94416 3.80883 3.30824 3.8643L2.59861 3.92615C2.22202 3.95901 2.01172 4.32404 2.17153 4.66638L2.47296 5.31156C2.74285 5.88997 2.62129 6.58039 2.16957 7.03162L1.66567 7.53487C1.39814 7.8024 1.47134 8.21692 1.8141 8.37667L2.45929 8.6768C3.03826 8.94623 3.38895 9.55391 3.33298 10.1898L3.27048 10.8988C3.23744 11.2754 3.55996 11.5463 3.92478 11.4483L4.61293 11.2634C5.22945 11.098 5.88763 11.3375 6.25356 11.8604L6.66176 12.4444C6.87849 12.7542 7.29985 12.7535 7.51658 12.4437L7.92478 11.8604C8.29071 11.3375 8.94953 11.098 9.56606 11.2634L10.2536 11.4483C10.6184 11.5463 10.9415 11.2754 10.9085 10.8988L10.846 10.1892C10.7903 9.5535 11.1403 8.94679 11.7191 8.67745L12.3642 8.37667C12.7069 8.21698 12.7799 7.80194 12.5127 7.53487L12.0094 7.03162C11.5577 6.58039 11.4361 5.88997 11.706 5.31156L12.0075 4.66638C12.1673 4.32404 11.9563 3.95901 11.5797 3.92615L10.8707 3.8643C10.2348 3.80883 9.69778 3.3585 9.53285 2.7419L9.34926 2.05375C9.25155 1.68848 8.85553 1.54451 8.54588 1.76143L7.96319 2.17029C7.44038 2.53665 6.73895 2.5362 6.2158 2.17029L5.63246 1.76143Z"
                          fill="#4890D2"
                        />
                      </svg>

                      <span v-if="showModal && offer.is_verified" class="tooltip">{{
                        $t("pages.common.buttons.dis125")
                      }}</span>
                    </div>
                  </div>
                 
                  <p
                    class="
                      flex
                      items-center
                      justify-start
                      mt-0.5
                      mb-0
                      text-xs
                      font-medium
                      text-darkgray1
                    "
                    @click="
                      () => {
                        if (loggedIn) {
                          $router.push({
                            name: 'offerDetails',
                            params: { id: offer.offer_id },
                          });
                        } else {
                          $router.push({ name: 'confirmCell' });
                        }
                      }
                    "
                  >
                    <span class="mr-1.5">
                      <svg
                        class="w-3.5 h-3.5"
                        viewBox="0 0 10 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                          fill="#676666"
                        />
                      </svg>
                    </span>
                    {{ offer.location }}
                  </p>
                </div>

                <div class="right-block w-2/4 relative">
                  <p
                    class="
                      wishlist-icon
                      relative
                      text-sm text-right
                      flex
                      items-center
                      justify-end
                      mt-0
                      font-bold
                    "
                  >
                    <button
                      v-if="offer.favorite"
                      @click.prevent="selectedOffers(offer.offer_id, offer)"
                      :offer="offer"
                    >
                      <svg
                        width="20"
                        height="18"
                        viewBox="0 0 20 18"
                        fill="none"
                        :active="true"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                          fill="#63B15B"
                        />
                        <path
                          d="M5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                          fill="#63B15B"
                        />
                      </svg>
                    </button>

                    <button
                      v-else
                      @click.prevent="selectedOffers(offer.offer_id, offer)"
                      :class="offer.favorite === true ? true : false"
                      :offer="offer"
                    >
                      <svg
                        width="20"
                        height="18"
                        viewBox="0 0 20 18"
                        class=""
                        :active="false"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                          fill="#63B15B"
                        />
                      </svg>
                    </button>
                  </p>
                </div>
              </div>
              <div
                class="flex bottom-block"
                @click="
                  () => {
                    if (loggedIn) {
                      $router.push({
                        name: 'offerDetails',
                        params: { id: offer.offer_id },
                      });
                    }
                  }
                "
              >
                <div class="left-block w-2/4 relative pl-4">
                  <h4
                    class="
                      flex
                      items-center
                      justify-items-start
                      relative
                      text-sm
                      font-bold
                      text-darkblack
                    "
                  >
                    {{
                      formatDate(offer.arrival_date, "DD.MM.YYYY", "YYYY-MM-DD")
                    }}
                  </h4>
                </div>
                <div class="right-block w-2/4 relative">
                  <h4
                    class="
                      flex
                      items-center
                      relative
                      text-smm
                      font-bold
                      text-darkblack
                      justify-end
                      pr-4
                    "
                  >
                    <span class="flex mr-1 mr-333">
                      <svg
                        class="w13-13 h13-13"
                        width="14"
                        height="15"
                        viewBox="0 0 14 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.00016 0.833008C3.32418 0.833008 0.333496 3.8237 0.333496 7.49967C0.333496 11.1757 3.32418 14.1663 7.00016 14.1663C10.6761 14.1663 13.6668 11.1757 13.6668 7.49967C13.6668 3.8237 10.6761 0.833008 7.00016 0.833008ZM7.17334 3.83301C8.49667 3.83301 9.06307 4.39182 9.51774 4.84082C9.71441 5.03482 9.7163 5.35118 9.5223 5.54785C9.32863 5.74452 9.01127 5.74641 8.81527 5.55241C8.40827 5.15074 8.08699 4.83301 7.17399 4.83301C6.37166 4.83301 5.67077 5.37067 5.29443 6.16634H6.8335C7.1095 6.16634 7.3335 6.39001 7.3335 6.66634C7.3335 6.94267 7.1095 7.16634 6.8335 7.16634H5.01904C5.00771 7.27567 5.00016 7.38667 5.00016 7.49967C5.00016 7.61267 5.00771 7.72367 5.01904 7.83301H6.8335C7.1095 7.83301 7.3335 8.05667 7.3335 8.33301C7.3335 8.60934 7.1095 8.83301 6.8335 8.83301H5.29443C5.6711 9.62867 6.37101 10.1663 7.17334 10.1663C8.08634 10.1663 8.40793 9.84861 8.81527 9.44694C9.01127 9.25294 9.32863 9.25516 9.5223 9.4515C9.7163 9.64816 9.71441 9.96486 9.51774 10.1585C9.06307 10.6079 8.49699 11.1663 7.17399 11.1663C5.83132 11.1663 4.68353 10.1967 4.22087 8.83301H3.50016C3.22416 8.83301 3.00016 8.60934 3.00016 8.33301C3.00016 8.05667 3.22416 7.83301 3.50016 7.83301H4.01514C4.00647 7.72301 4.00016 7.61234 4.00016 7.49967C4.00016 7.38701 4.00647 7.27634 4.01514 7.16634H3.50016C3.22416 7.16634 3.00016 6.94267 3.00016 6.66634C3.00016 6.39001 3.22416 6.16634 3.50016 6.16634H4.22021C4.68322 4.80267 5.83101 3.83301 7.17334 3.83301Z"
                          fill="#63B15B"
                        />
                      </svg>
                    </span>
                    {{ formatPrice(offer.compensation) }} Euro
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FavoriteFilters :show-filters.sync="showFilters" />
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";
import FavoriteFilters from "@/components/modals/FavoriteFilters";

export default {
  name: "Favorites",
  components: { FavoriteFilters, LoadingSpinner },
  data() {
    return {
      showSortingOptions: false,
      loading: true,
      showFilters: false,
      isModalVisible: false,
      showModal: false,
    };
  },
  computed: {
    offers() {
      return this.$store.getters["offer/favorites"];
    },
    orderBy() {
      return this.$store.getters["offer/orderBy"];
    },
    sortDir() {
      return this.$store.getters["offer/sortDir"];
    },
  },
  created() {
    this.fetchList();
  },

  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    showVerifiedModal() {
      this.showModal = true;
      setTimeout(() => {
        this.showModal = false;
      }, 1000);
    },
    sort(orderBy, dir) {
      this.$store.commit("offer/setOrderBy", orderBy);
      this.$store.commit("offer/setSortDir", dir);
      this.fetchList();
    },
    resetFilter() {
      this.$store.commit("app/showNotification", {
        heading: this.$t("pages.common.buttons.questions1"),
        desc: this.$t("pages.common.buttons.questions2"),
        buttons: {
          okay: {
            text: this.$t("pages.common.buttons.questions1"),
            action: () => {
              this.resetFilters = true;
              this.showFilters = true;
            },
          },
          cancel: {
            text: this.$t("pages.common.buttons.questions3"),
            action: () => {},
          },
        },
      });
    },
    selectedOffers(id, val) {
      this.$store.dispatch("offer/toggleFav", {
        offerId: id,
        page: "list",
      });
      val.favorite = !val.favorite;
         this.$store.dispatch("offer/favorites").then((res) => {
       
      });
     
    
   
    },
    fetchList() {
      this.loading = true;
      this.showSortingOptions = false;
      this.$store.dispatch("offer/favorites").then((res) => {
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.modal-vue .overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-vue .modal {
  position: relative;
  width: 300px;
  z-index: 9999;
  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
}

.modal-vue .close {
  position: absolute;
  top: 10px;
  right: 10px;
}
.tooltip {
 position: absolute;
    top: -18px;
    margin-left: 26px;
    max-width: 236px;
    opacity: 0;
 
  padding: 10px;
  height: 37px;
 
  color: white;
  text-align: center;
  background: #63b15b;
  border-radius: 5px;
  white-space: nowrap;
}

.wrapper:hover > .tooltip {
  opacity: 1;
}
.reset_fill {
  color: #63b15b;
}
</style>
